const en = {
  app: {
    title: 'AllPhi Mobility',
    subtitle: 'Employee portal',
    logoAlt: 'AllPhi logo',
    signOut: 'Sign out',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    language: 'Language',
    dutch: 'Dutch',
    english: 'English',
    accountMenu: 'Account menu',
  },
  nav: {
    budget: 'My budget',
    claims: 'My expense claims (Pillar 2)',
  },
  auth: {
    title: 'AllPhi Mobility portal',
    subtitle: 'Sign in with your Microsoft work account to continue.',
    signIn: 'Sign in',
  },
  common: {
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    invalidDateFormat: 'Use a valid date in dd/mm/yyyy format.',
    datePlaceholder: 'dd/mm/yyyy',
  },
  mobility: {
    fields: {
      year: 'Year',
      annualBudget: 'Annual budget',
      availableBalance: 'Available balance',
      status: 'Status',
      actions: 'Actions',
      date: 'Date',
      entryType: 'Entry type',
      amount: 'Amount',
      description: 'Description',
      attachments: 'Attachments',
    },
    accounts: {
      stateClosed: 'Closed',
    },
    ledger: {
      types: {
        BudgetGrant: 'Annual budget',
        CarCost: 'Vehicle cost',
        ExpenseReimbursement: 'Expense',
        CashPayout: 'Pillar 3 payout',
        Adjustment: 'Adjustment',
        MonthlyRelease: 'Monthly release',
        YearlyRelease: 'Yearly release',
      },
      descriptions: {
        MonthlyRelease: 'Mobility budget released at the end of the month',
        YearlyRelease: 'Full remaining annual budget released in one go',
        ExpenseReimbursement: 'Expense claim reimbursement #{{id}}',
        ExpenseReimbursementDetailed: '{{type}}',
        ExpenseRefund: 'Refund of cancelled expense claim #{{id}}',
        ExpenseRefundDetailed: 'Reversal: {{type}}',
      },
    },
    claimStatus: {
      Draft: 'Draft',
      Submitted: 'Submitted',
      UnderReview: 'Under review',
      Approved: 'Approved',
      Rejected: 'Rejected',
      PayrollReady: 'Payroll ready',
      Processed: 'Processed',
      Cancelled: 'Cancelled',
    },
    self: {
      notLinkedTitle: 'No mobility profile found',
      notLinked: 'Your account is not yet linked to an employee profile. Please contact HR or Finance.',
      budgetInactiveTitle: 'Mobility budget not active yet',
      budgetInactiveMessage: 'Your current and assigned category are already visible. Lease details, TCO amounts, mobility-budget calculations and expense claims are only shown once mobility budget is active.',
      budgetTitle: 'My mobility budget',
      budgetSubtitle: 'View your annual budget, category and transactions.',
      balanceCardTitle: 'My available budget',
      balanceCardSubtitle: 'What you can actually use today',
      availableNow: 'Available now for expenses',
      regularReleased: 'Released normally for Pillar 2',
      budgetComposition: 'Annual budget for Pillars 2 and 3',
      annualBudgetPillars: 'Annual budget for Pillars 2 and 3',
      annualBudgetExplanation: 'This amount is the difference between your total mobility budget and Pillar 1, calculated pro rata by day from {{startDate}} through {{endDate}} within book year {{year}}.',
      annualBudgetExplanationNoLease: 'This is the available annual budget for Pillars 2 and 3 in book year {{year}}.',
      yearlyReleaseLeaverDisclaimer: 'If you leave the company, this budget will be recalculated from 01/01/{{year}} through your last day of employment, pro rata by calendar day.',
      usageAndProjection: 'Pillar 2 usage and Pillar 3 projection',
      perMonth: 'per month',
      expenses: 'Used through expense claims (Pillar 2)',
      projectedPillarThree: 'Projected net payout (Pillar 3)',
      pillarThreeDescription: 'Pillar 3 pays the remaining budget in cash at the end of the book year. A special employee contribution is withheld from the gross amount.',
      pillarThreeExplanation: 'Projection if expenses remain unchanged: {{gross}} gross, less {{contribution}} special employee contribution ({{rate}}%).',
      monthEndReleaseInfo: 'Each month\'s budget only becomes available on the final calendar day of that month.',
      releaseModeYearly: 'Yearly release',
      switchToYearlyRelease: 'Switch to yearly release',
      switchToYearlyReleaseTitle: 'Switch to yearly release',
      switchToYearlyReleaseWarning: 'Once you switch, your entire annual Pillar 2/3 budget becomes available immediately instead of being released month by month. You will lose the monthly "earned so far" indicator for the rest of this book year. This choice is locked for {{year}} and cannot be reverted. If you leave the company, your budget is still recalculated pro rata to your departure date.',
      switchToYearlyReleaseConfirmLabel: 'I understand and want to switch to yearly release.',
      switchToYearlyReleaseConfirm: 'Switch to yearly release',
      switchToYearlyReleaseSuccess: 'Your mobility budget is now released yearly for {{year}}.',
      profileCardTitle: 'My category and vehicle',
      profileCardSubtitle: 'Your current situation and next transition',
      nextCategoryInfo: 'You will move to category {{category}} on {{date}}.',
      overheadCategoryInfo: 'Your category is fixed by company policy and is not calculated from years of experience or points.',
      categoryRuleUpgrade: 'Your current lease runs from {{startDate}} through {{endDate}}. Your formula-based category is now {{calculatedCategory}}. Because it is higher than your assigned category {{assignedCategory}}, you can move to category {{nextCategory}} when choosing your next vehicle from {{switchDate}}. Your assigned category does not change automatically during the current lease.',
      categoryRuleNoUpgrade: 'Your current lease runs from {{startDate}} through {{endDate}}. Your formula-based category is now {{calculatedCategory}} and your assigned category is {{assignedCategory}}. That assigned category does not change automatically during the current lease. When choosing your next vehicle, eligibility for a higher category is assessed again using the formula.',
      highestCategory: 'You are already in the highest category.',
      vehicleDetailsTitle: 'Mobility budget composition',
      leasePeriod: 'Lease period',
      entitledMonthlyTco: 'Total mobility budget',
      entitledMonthlyTcoHelper: 'The full monthly amount to which you are entitled.',
      vehicleMonthlyTco: 'Pillar 1 · Company car',
      vehicleMonthlyTcoHelper: 'The monthly amount used for your current company car.',
      monthlyMobilityDifference: 'Available for Pillar 2 or 3',
      monthlyMobilityDifferenceHelper: 'For Pillar 2 expenses or the Pillar 3 year-end payout.',
      noAccount: 'You do not have a mobility budget account for {{year}} yet.',
      category: 'Mobility category',
      currentCategory: 'Current category',
      assignedCategory: 'Assigned category',
      eligibleCategory: 'Current category',
      vehicleCategory: 'Mobility-budget category',
      noCategory: 'Not set',
      noVehicle: 'No active vehicle assigned',
      employmentStartDate: 'Employment start date',
      yearsBeforeCompany: 'Experience before AllPhi',
      allowedChoices: 'Allowed choices',
      relevantYears: 'Relevant experience (years)',
      points: 'Points',
      ledgerTitle: 'Transactions',
      ledgerSubtitle: 'A clear overview of monthly releases, early releases and expenses.',
      noTransactions: 'No transactions for this year yet',
      rowsPerPage: 'Rows per page:',
      claimsTitle: 'My expense claims (Pillar 2)',
      claimsSubtitle: 'Submit expenses for reimbursement from your mobility budget (Pillar 2).',
      newClaim: 'New expense claim',
      createTitle: 'Submit an expense claim',
      createSubtitle: 'Choose an eligible expense, enter the details and attach your supporting document.',
      pillarTwoIntro: 'Pillar 2 expenses are exempt from tax and social-security contributions. The cost of any company car is deducted from your mobility budget first.',
      stepExpenseType: 'Step 2',
      chooseExpenseType: 'What did you spend money on?',
      chooseSpecificExpense: 'Choose the appropriate expense type',
      expenseTypesError: 'The expense types could not be loaded. Please try again later.',
      noExpenseTypes: 'There are currently no expense types available. Please contact Finance.',
      eligibilityTitle: 'What is eligible under Pillar 2?',
      eligibilitySubtitle: 'Review the conditions and examples before submitting.',
      eligibilityWarning: 'Airline tickets and moving expenses are not eligible. Motorised vehicles under soft or shared mobility must be emission-free for purchases, rentals or leases from 1 January 2026.',
      stepExpenseDetails: 'Step 1',
      expenseDetailsTitle: 'Expense details',
      descriptionPlaceholder: 'Briefly describe what you purchased or which service you used.',
      stepProof: 'Step 3',
      proofTitle: 'Proof of expense',
      proofRequired: 'An invoice, ticket or proof of payment is required for this expense type.',
      proofOptional: 'Preferably attach an invoice, ticket or proof of payment.',
      proofChip: 'Proof required',
      proofDropTitle: 'Drop your supporting document here',
      proofFormats: 'PDF, JPG or PNG · maximum 10 MB',
      chooseProof: 'Choose file',
      replaceProof: 'Replace file',
      proofUploaded: 'Supporting document uploaded',
      proofInvalidType: 'Use a PDF, JPG or PNG file.',
      proofTooLarge: 'The file may be no larger than 10 MB.',
      draftCreatedRetry: 'Your draft has been saved. Uploading or submitting did not finish; you can retry below.',
      createAndSubmit: 'Submit expense claim',
      retrySubmit: 'Try again',
      createdAndSubmitted: 'Your expense claim and supporting document have been submitted.',
      expenseType: 'Expense type',
      amount: 'Amount',
      date: 'Payment date',
      expenseCoversPeriod: 'This expense covers a period',
      periodEndDate: 'Period end date',
      expensePeriod: 'Expense period',
      description: 'Description',
      descriptionOptional: 'Note (optional)',
      noDescription: 'No description provided',
      addAttachment: 'Add attachment',
      submit: 'Submit',
      cancel: 'Cancel',
      created: 'Expense claim created.',
      submitted: 'Expense claim submitted.',
      cancelled: 'Expense claim cancelled.',
      attachmentAdded: 'Attachment added.',
      attachmentRequired: 'This expense type requires an attachment.',
      useToday: 'Use today',
      claimDetailsTitle: 'Expense claim details',
      rejectionReason: 'Reason for rejection',
      noRejectionReason: 'The reviewer did not provide a reason.',
      attachmentsTitle: 'Supporting documents',
      noAttachments: 'No supporting documents were added.',
      reviseAndResubmit: 'Edit and resubmit',
      reviseTitle: 'Edit rejected expense claim',
      reviseExplanation: 'Update the information and add a new supporting document if needed. Finance will review the claim again after submission.',
      addReplacementProof: 'Add new supporting document',
      resubmit: 'Resubmit',
      resubmitted: 'Your expense claim was updated and resubmitted.',
      homeAddress: 'Home address',
      workAddress: 'Work address',
      street: 'Street',
      houseNumber: 'No.',
      postalCode: 'Postcode',
      city: 'Municipality',
      amountToBeCalculated: 'To be calculated',
      distanceCalculationInfo: 'For commuting you do not enter an amount. Enter your home and work address: F&A determines the distance and calculates the amount (kilometres × price per kilometre). The shortest distance between both addresses is used for the calculation.',
      distanceCalculation: 'Calculation',
      distanceBreakdown: '{{km}} km × {{rate}} per km',
    },
    claimCategories: {
      softMobility: { short: 'Bicycle, scooter, moped, electric motorcycle and protective equipment.' },
      publicTransport: { short: 'Passes and tickets for train, tram, bus, metro or waterbus.' },
      collectiveTransport: { short: 'Organised transport, such as an office shuttle.' },
      sharedMobility: { short: 'Shared transport, taxi, carpooling or short-term vehicle rental.' },
      mobilityServices: { short: 'A combination of sustainable mobility services.' },
      housing: { short: 'Rent or mortgage for a home within 10 km of work.' },
      bicycleAllowance: { short: 'Allowance for commuting actually done by bicycle.' },
      parking: { short: 'Parking linked to a public-transport pass.' },
      pedestrian: { short: 'Allowance for commuting on foot.' },
      management: { short: 'Costs for administering the mobility budget.' },
      other: { short: 'Another eligible sustainable mobility expense.' },
    },
    expenseGroups: {
      transport: {
        title: 'Sustainable transport',
        subtitle: 'Transport modes and services',
      },
      housing: {
        title: 'Housing',
        subtitle: 'Living close to work',
      },
      allowances: {
        title: 'Commuting',
        subtitle: 'Cycling and pedestrian allowance',
      },
    },
    eligibility: {
      softMobility: {
        title: 'Soft mobility',
        description: 'Purchase, rental, lease, financing, maintenance and storage of bicycles, scooters, mopeds, electric motorcycles and certain electric three- or four-wheelers. Safety and visibility equipment such as helmets and reflective vests may also qualify.',
      },
      publicTransport: {
        title: 'Public transport',
        description: 'Passes for the employee and household members, plus individual tickets for people of their choice. Train, tram, bus, metro, waterbus, intercity bus and high-speed rail are eligible; flights are not.',
      },
      collectiveAndShared: {
        title: 'Collective transport, shared solutions and mobility services',
        description: 'Includes office shuttles, carpooling, shared cars, scooters, bicycles and steps, taxis and platform services. A vehicle without a driver may be rented for at most 30 calendar days per year.',
      },
      housing: {
        title: 'Housing costs',
        description: 'Rent, mortgage interest and capital repayments qualify when the home is within a 10 km straight-line radius of the normal workplace. Moving expenses are excluded.',
      },
      allowances: {
        title: 'Cycling allowance, parking and pedestrian allowance',
        description: 'These allowances require a demonstrable link to commuting. Parking costs are only eligible when connected to the use of public transport.',
      },
      management: {
        title: 'Administration costs',
        description: 'Costs for administering the mobility budget can be charged under Pillar 2 since 1 January 2024.',
      },
    },
  },
};

export default en;
